// couponSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notify, notifyAPIMessages } from "../../../helpers/commonFunctions";
import { BASE_URL } from "../../../config";
import axios from "axios";
import { authHeaders } from "../../../helpers/axios";
import { apiEndPoints } from "../../../helpers/constants";

// Add Staff
export const reqToAddCoupon = createAsyncThunk(
  "reqToAddCoupon",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.post(
        BASE_URL + apiEndPoints.addCoupon,
        data,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Get Staff List
export const reqToGetCouponList = createAsyncThunk(
  "reqToGetCouponList",
  async ({ data, onSuccess, onFailure }, thunkAPI) => {

    try {
      const response = await axios.get(
        `${BASE_URL}${apiEndPoints.getCouponList}?tab=${data?.tab || ""}&search=${
          data?.search || ""
        }&page=${data?.page || 1}&limit=${data?.limit || 10}`,
        authHeaders()
      );
      onSuccess(response?.data);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Get Staff Details
export const reqToGetCouponDetails = createAsyncThunk(
  "reqToGetCouponDetails",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL + apiEndPoints.getCouponDetails}/${id}`,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Update Staff
export const reqToUpdateCoupon = createAsyncThunk(
  "reqToUpdateCoupon",
  async ({ id, data, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BASE_URL}${apiEndPoints.updateCoupon}/${id}`,
        data,
        authHeaders()
      );      
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

// Delete Staff
export const reqToDeleteCoupon = createAsyncThunk(
  "reqToDeleteCoupon",
  async ({ id, onSuccess, onFailure }, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}${apiEndPoints.deleteCoupon}/${id}`,
        authHeaders()
      );      
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return thunkAPI.rejectWithValue({
        message: error?.response?.data?.message || "Network Error",
        status: error?.response?.status,
      });
    }
  }
);

const couponSlice = createSlice({
  name: "promotionCoupons",
  initialState: {
    loader: false,
    error: null,
    CouponList: [],
    CouponDetails: {},
    totalCount: 0,
  },
  reducers: {
    // Add any specific reducers if needed
  },
  extraReducers: (builder) => {
    // ADD STAFF
    builder.addCase(reqToAddCoupon.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToAddCoupon.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToAddCoupon.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET STAFF LIST
    builder.addCase(reqToGetCouponList.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetCouponList.fulfilled, (state, action) => {
      state.loader = false;
      state.CouponList = action.payload?.data?.result || [];
      state.totalCount = action.payload.headers["x-total-count"];
    });
    builder.addCase(reqToGetCouponList.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // GET STAFF DETAILS
    builder.addCase(reqToGetCouponDetails.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetCouponDetails.fulfilled, (state, action) => {
      state.loader = false;
      state.CouponDetails = action.payload?.data?.result || {};
    });
    builder.addCase(reqToGetCouponDetails.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload?.message || "Something went wrong");
    });

    // UPDATE STAFF
    builder.addCase(reqToUpdateCoupon.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToUpdateCoupon.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToUpdateCoupon.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // DELETE STAFF
    builder.addCase(reqToDeleteCoupon.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToDeleteCoupon.fulfilled, (state, action) => {
      state.loader = false;
    });
    builder.addCase(reqToDeleteCoupon.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });
  },
});

export const { } = couponSlice.actions;
export default couponSlice.reducer;